import React, { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { ClipLoader } from "react-spinners";
import { FaCheckCircle, FaTimesCircle, FaEdit, FaTrash } from "react-icons/fa";
import { SERVER_URL } from "../../constants.js";
import axios from "axios";

const ProductList = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingProduct, setEditingProduct] = useState(null);
   const [categories, setCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);

  useEffect(() => {
    const getProducts = async () => {
      try {
        const response = await axios.get(`${SERVER_URL}/api/v1/product`);
        const response2 = await fetch(`${SERVER_URL}/api/v1/category`);
        const data2 = await response2.json();
        
        // Extract the 'name' property from each category
        const categoryNames = data2.data.map((category) => category.name);
        
   
        setCategories(categoryNames);
        const response3 = await axios.get(`${SERVER_URL}/api/v1/subcategory`);
        const {n}=response3.data
        const uniqueSubcategories = [...new Set(n)];
        setSubcategories(uniqueSubcategories);
        console.log('234834384348343',n)
        const { data } = response.data;
        setProducts(data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error.message);
        console.error("Failed to fetch products:", error);
      }
    };
    getProducts();
  }, []);

  const handleRowClick = (product) => setSelectedProduct(product);

  const handleSaveChanges = async (updatedProduct) => {
    setLoading(true);
    try {
      const response = await axios.put(`${SERVER_URL}/api/v1/product/${updatedProduct._id}`, updatedProduct);
      if (response.status === 200) {
        setProducts((prevProducts) =>
          prevProducts.map((product) =>
            product._id === updatedProduct._id ? updatedProduct : product
          )
        );
      }
    } catch (error) {
      console.error("Failed to update product:", error);
    }
    setLoading(false);
    setEditingProduct(null);
  };

  const handleDeleteProduct = async (productId) => {
    setLoading(true);
    try {
      const response = await axios.delete(`${SERVER_URL}/api/v1/product/${productId}`);
      if (response.status === 200) {
        setProducts((prevProducts) => prevProducts.filter((product) => product._id !== productId));
      }
    } catch (error) {
      console.error("Failed to delete product:", error);
    }
    setLoading(false);
  };

  const handleEditClick = (product) => {
    setEditingProduct({ ...product });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditingProduct((prev) => ({ ...prev, [name]: value }));
  };

  const handleVariationChange = (index, field, value) => {
    const updatedVariations = [...editingProduct.variations];
    updatedVariations[index] = { ...updatedVariations[index], [field]: value };
    setEditingProduct((prev) => ({ ...prev, variations: updatedVariations }));
  };

  const addFeature = () => {
    setEditingProduct((prev) => ({ ...prev, features: [...(prev.features || []), ""] }));
  };

  const removeFeature = (index) => {
    setEditingProduct((prev) => {
      const updatedFeatures = [...(prev.features || [])];
      updatedFeatures.splice(index, 1);
      return { ...prev, features: updatedFeatures };
    });
  };

  const handleFeatureChange = (index, value) => {
    setEditingProduct((prev) => {
      const updatedFeatures = [...(prev.features || [])];
      updatedFeatures[index] = value;
      return { ...prev, features: updatedFeatures };
    });
  };

  const addManufacturer = () => {
    setEditingProduct((prev) => ({ ...prev, manufacturers: [...(prev.manufacturers || []), ""] }));
  };

  const removeManufacturer = (index) => {
    setEditingProduct((prev) => {
      const updatedManufacturers = [...(prev.manufacturers || [])];
      updatedManufacturers.splice(index, 1);
      return { ...prev, manufacturers: updatedManufacturers };
    });
  };

  const handleManufacturerChange = (index, value) => {
    setEditingProduct((prev) => {
      const updatedManufacturers = [...(prev.manufacturers || [])];
      updatedManufacturers[index] = value;
      return { ...prev, manufacturers: updatedManufacturers };
    });
  };

  const renderStock = (totalStock) => {
    return totalStock > 0 ? <FaCheckCircle color="green" /> : <FaTimesCircle color="red" />;
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <ClipLoader size={150} color={"#123abc"} loading={loading} />
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }
  const handleImageChange = (index, value) => {
    setEditingProduct((prev) => {
      const updatedImages = [...(prev.imgUrl || [])];
      updatedImages[index] = value;
      return { ...prev, imgUrl: updatedImages };
    });
  };
  
  const addImage = () => {
    setEditingProduct((prev) => ({
      ...prev,
      imgUrl: [...(prev.imgUrl || []), ""],
    }));
  };
  
  const removeImage = (index) => {
    setEditingProduct((prev) => {
      const updatedImages = [...(prev.imgUrl || [])];
      updatedImages.splice(index, 1);
      return { ...prev, imgUrl: updatedImages };
    });
  };
  const handleFileUpload = async (index, file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", 'unsigned_preset');
  
    try {
      const response = await fetch(
        `https://api.cloudinary.com/v1_1/dpgf1rkjl/image/upload`,
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await response.json();
      const imageUrl = data.secure_url;
  
      setEditingProduct((prev) => {
        const updatedImages = [...(prev.imgUrl || [])];
        updatedImages[index] = imageUrl;
        return { ...prev, imgUrl: updatedImages };
      });
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };
  

  return (
    <div className="bg-white text-gray-900 p-6 mt-6 rounded-lg shadow-lg">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-400 via-blue-500 to-purple-600">
          List of Products
        </h2>
        <button
          className="bg-gradient-to-r from-blue-500 to-purple-600 text-white px-5 py-2 rounded-lg flex items-center shadow-lg"
        >
          <Plus className="w-5 h-5 mr-2" />
          Add Product
        </button>
      </div>

      {editingProduct ? (
        <div className="p-4 bg-gray-100 rounded-md mb-6">
          <h3 className="text-lg font-semibold mb-4">Edit Product</h3>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSaveChanges(editingProduct);
            }}
          >
            <div className="grid grid-cols-2 gap-4">
              <label>Product Code</label>
              <input
                type="text"
                name="productCode"
                value={editingProduct.productCode}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-lg p-2 w-full"
              />
              <label>Name</label>
              <input
                type="text"
                name="name"
                value={editingProduct.name}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-lg p-2 w-full"
              />
              <label>Price</label>
              <input
                type="number"
                name="price"
                value={editingProduct.price}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-lg p-2 w-full"
              />
               <label className="block mb-1 font-semibold text-gray-800">Top Status</label>
          <select
            name="top"
            value={editingProduct.top}
            onChange={handleInputChange}
            className="border border-gray-300 rounded-lg p-2 w-full"
          >
            <option value="">Select Status</option>
            <option value="topDeals">Top Deals</option>
            <option value="topSelling">Top Selling</option>
            <option value="topTrending">Top Trending</option>
            <option value="topFeatured">Top Featured</option>
            <option value="hotTrending">Hot Trending</option>
          </select>
              <label>Total Stock</label>
              <input
                type="number"
                name="totalStock"
                value={editingProduct.totalStock}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-lg p-2 w-full"
              />
              <label>Category</label>
              <select
                type="text"
                name="category"
                value={editingProduct.category}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-lg p-2 w-full"
                
              >
                <option value="">Select Category</option>
    {categories.map((category) => (
      <option key={category.id} value={category.name}>
        {category}
      </option>
    ))}</select>
              <label>Subcategory</label>
              <select
                type="text"
                name="subcategory"
                value={editingProduct.subcategory}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-lg p-2 w-full"
              >
                 <option value="">Select Subcategory</option>
            {subcategories.map((subcategory, index) => (
              <option key={index} value={subcategory}>
                {subcategory}
              </option>
            ))}
          </select>
              <label>Description</label>
              <textarea
                name="description"
                value={editingProduct.description}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-lg p-2 w-full"
              />
              <label>Original Price</label>
              <input
                type="number"
                name="originalPrice"
                value={editingProduct.originalPrice}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-lg p-2 w-full"
              />
              <label>Discount</label>
              <input
                type="number"
                name="discount"
                value={editingProduct.discount}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-lg p-2 w-full"
              />
            </div>
            <h4 className="text-lg font-semibold mt-6">Images</h4>
            {editingProduct.imgUrl?.map((img, index) => (
  <div key={index} className="flex flex-col space-y-2 mb-4">
    <input
      type="text"
      value={img}
      onChange={(e) => handleImageChange(index, e.target.value)}
      placeholder="Image URL"
      className="border border-gray-300 rounded-lg p-2 w-full"
    />
    <img
      src={img || "https://via.placeholder.com/150"}
      alt={`Preview ${index + 1}`}
      className="w-32 h-32 object-cover rounded-md"
    />
    <label className="text-gray-500 mt-2">
      Upload from device:
      <input
        type="file"
        accept="image/*"
        onChange={(e) => handleFileUpload(index, e.target.files[0])}
        className="hidden"
      />
    </label>
    <button
      type="button"
      onClick={() => removeImage(index)}
      className="text-red-500 mt-2"
    >
      Remove
    </button>
  </div>
))}
<button type="button" onClick={addImage} className="text-blue-500 mt-2">
  Add Image
</button>;

            <h4 className="text-lg font-semibold mt-6">Features</h4>
            {editingProduct.features?.map((feature, index) => (
              <div key={index} className="flex items-center space-x-2">
                <input
                  type="text"
                  value={feature}
                  onChange={(e) => handleFeatureChange(index, e.target.value)}
                  className="border border-gray-300 rounded-lg p-2 w-full"
                />
                <button
                  type="button"
                  onClick={() => removeFeature(index)}
                  className="text-red-500"
                >
                  Remove
                </button>
              </div>
            ))}
            <button type="button" onClick={addFeature} className="text-blue-500 mt-2">
              Add Feature
            </button>
            <h4 className="text-lg font-semibold mt-6">Manufacturers</h4>
            {editingProduct.manufacturers?.map((manufacturer, index) => (
              <div key={index} className="flex items-center space-x-2">
                <input
                  type="text"
                  value={manufacturer}
                  onChange={(e) => handleManufacturerChange(index, e.target.value)}
                  className="border border-gray-300 rounded-lg p-2 w-full"
                />
                <button
                  type="button"
                  onClick={() => removeManufacturer(index)}
                  className="text-red-500"
                >
                  Remove
                </button>
              </div>
            ))}
            <button type="button" onClick={addManufacturer} className="text-blue-500 mt-2">
              Add Manufacturer
            </button>
            <h4 className="text-lg font-semibold mt-6">Variations</h4>
            {editingProduct.variations?.map((variation, index) => (
              <div key={index} className="p-4 border border-gray-300 rounded-lg mb-2">
                <label>Size</label>
                <input
                  type="text"
                  value={variation.size || ""}
                  onChange={(e) => handleVariationChange(index, "size", e.target.value)}
                  className="border border-gray-300 rounded-lg p-2 w-full mb-2"
                />
                <label>Color</label>
                <input
                  type="text"
                  value={variation.color || ""}
                  onChange={(e) => handleVariationChange(index, "color", e.target.value)}
                  className="border border-gray-300 rounded-lg p-2 w-full mb-2"
                />
                <label>Stock</label>
                <input
                  type="number"
                  value={variation.stock || ""}
                  onChange={(e) => handleVariationChange(index, "stock", e.target.value)}
                  className="border border-gray-300 rounded-lg p-2 w-full mb-2"
                />
                
                <button
                  type="button"
                  onClick={() => setEditingProduct((prev) => ({
                    ...prev,
                    variations: prev.variations.filter((_, i) => i !== index),
                  }))}
                  className="text-red-500"
                >
                  Remove Variation
                </button>
              </div>
            ))}
            <button
              type="button"
              onClick={() => setEditingProduct((prev) => ({ ...prev, variations: [...prev.variations, { size: "", color: "", stock: 0 }] }))}
              className="text-blue-500 mt-2"
            >
              Add Variation
            </button>
            <div className="flex justify-end mt-4">
              <button
                type="submit"
                className="bg-blue-500 text-white px-4 py-2 rounded-md shadow-md mr-2"
              >
                Save
              </button>
              <button
                type="button"
                onClick={() => setEditingProduct(null)}
                className="bg-red-500 text-white px-4 py-2 rounded-md shadow-md"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left text-gray-600">
            <thead className="bg-gradient-to-r from-gray-100 to-gray-50 text-gray-800 uppercase font-semibold">
              <tr>
                <th className="py-3 px-6">Index</th>
                <th className="py-3 px-6">Product Code</th>
                <th className="py-3 px-6">Product Photo</th>
                <th className="py-3 px-6">Name</th>
                <th className="py-3 px-6">Price</th>
                <th className="py-3 px-6">Stock</th>
                <th className="py-3 px-6">Category</th>
                <th className="py-3 px-6">Subcategory</th>
                <th className="py-3 px-6">Top Status</th>
                <th className="py-3 px-6">Actions</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product, index) => (
                <tr
                  key={product._id}
                  className="border-b hover:bg-gray-100 cursor-pointer"
                >
                  <td className="py-4 px-6 font-semibold">{index + 1}</td>
                  <td className="py-4 px-6 text-blue-600 font-semibold">#{product.productCode}</td>
                  <td className="py-4 px-6">
                    <img
                      src={product.imgUrl[0] || "https://via.placeholder.com/150"}
                      alt={product.name}
                      className="w-16 h-16 object-cover rounded-md"
                    />
                  </td>
                  <td className="py-4 px-6">{product.name}</td>
                  <td className="py-4 px-6">${product.price.toFixed(2)}</td>
                  <td className="py-4 px-6">{renderStock(product.totalStock)}</td>
                  <td className="py-4 px-6">{product.category || "N/A"}</td>
                  <td className="py-4 px-6">{product.subcategory || "N/A"}</td>
                  <td className="py-4 px-6">{product.top || "N/A"}</td>
                  <td className="py-4 px-6">
                    <button
                      onClick={() => handleEditClick(product)}
                      className="text-blue-500 mr-4"
                    >
                      <FaEdit />
                    </button>
                    <button
                      onClick={() => handleDeleteProduct(product._id)}
                      className="text-red-500"
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ProductList;